<div class="text-expander">
  <span class="text-wrapper" [ngClass]="textClass">
    {{ textInput }}
  </span>
  @if (exceedsMaxNumRows) {
    <span
      class="show-more"
      [ngClass]="expanded ? 'expanded' : ''"
      (click)="toggle()"
      >
      {{ toggleText }}
      <i
        class="far"
        [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
      ></i>
    </span>
  }
</div>
